module.exports = __webpack_public_path__ + "static/media/csk-desktop-1220x150@2x-80.5540f665.jpg";